const S = "rgba(91,155,213,0.09)";

export default function CadSketch({ className = "" }) {
  return (
    <svg
      viewBox="0 0 920 720"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute inset-0 w-full h-full pointer-events-none select-none ${className}`}
      aria-hidden="true"
    >
      {/* Outer pump housing */}
      <circle cx="590" cy="360" r="232" stroke={S} strokeWidth="0.8" />
      {/* Intermediate ring */}
      <circle cx="590" cy="360" r="167" stroke={S} strokeWidth="0.5" strokeDasharray="6 3" />
      {/* Impeller circle */}
      <circle cx="590" cy="360" r="110" stroke={S} strokeWidth="0.7" />
      {/* Hub bore */}
      <circle cx="590" cy="360" r="58" stroke={S} strokeWidth="0.5" />
      {/* Shaft bore */}
      <circle cx="590" cy="360" r="21" stroke={S} strokeWidth="0.6" />

      {/* Horizontal centerline (chain-dot) */}
      <line x1="220" y1="360" x2="960" y2="360" stroke={S} strokeWidth="0.5" strokeDasharray="12 4 2 4" />
      {/* Vertical centerline */}
      <line x1="590" y1="60" x2="590" y2="660" stroke={S} strokeWidth="0.5" strokeDasharray="12 4 2 4" />

      {/* 6 radial construction lines */}
      <line x1="611" y1="360" x2="778" y2="360" stroke={S} strokeWidth="0.35" strokeDasharray="3 4" />
      <line x1="580" y1="339" x2="673" y2="191" stroke={S} strokeWidth="0.35" strokeDasharray="3 4" />
      <line x1="568" y1="339" x2="475" y2="191" stroke={S} strokeWidth="0.35" strokeDasharray="3 4" />
      <line x1="569" y1="360" x2="402" y2="360" stroke={S} strokeWidth="0.35" strokeDasharray="3 4" />
      <line x1="568" y1="381" x2="475" y2="529" stroke={S} strokeWidth="0.35" strokeDasharray="3 4" />
      <line x1="580" y1="381" x2="673" y2="529" stroke={S} strokeWidth="0.35" strokeDasharray="3 4" />

      {/* Bolt holes (6 on PCD r=193) */}
      <circle cx="783" cy="360" r="9" stroke={S} strokeWidth="0.5" />
      <circle cx="687" cy="527" r="9" stroke={S} strokeWidth="0.5" />
      <circle cx="493" cy="527" r="9" stroke={S} strokeWidth="0.5" />
      <circle cx="397" cy="360" r="9" stroke={S} strokeWidth="0.5" />
      <circle cx="493" cy="193" r="9" stroke={S} strokeWidth="0.5" />
      <circle cx="687" cy="193" r="9" stroke={S} strokeWidth="0.5" />

      {/* Overall diameter dimension line */}
      <line x1="358" y1="638" x2="822" y2="638" stroke={S} strokeWidth="0.5" />
      <line x1="358" y1="630" x2="358" y2="646" stroke={S} strokeWidth="0.5" />
      <line x1="822" y1="630" x2="822" y2="646" stroke={S} strokeWidth="0.5" />
      <line x1="358" y1="592" x2="358" y2="640" stroke={S} strokeWidth="0.4" strokeDasharray="3 3" />
      <line x1="822" y1="592" x2="822" y2="640" stroke={S} strokeWidth="0.4" strokeDasharray="3 3" />

      {/* Left side orthographic view */}
      <rect x="62" y="210" width="76" height="300" stroke={S} strokeWidth="0.6" />
      <line x1="62" y1="288" x2="138" y2="288" stroke={S} strokeWidth="0.4" />
      <line x1="62" y1="432" x2="138" y2="432" stroke={S} strokeWidth="0.4" />
      <line x1="62" y1="360" x2="138" y2="360" stroke={S} strokeWidth="0.4" strokeDasharray="8 3 2 3" />
      <line x1="100" y1="210" x2="100" y2="510" stroke={S} strokeWidth="0.4" strokeDasharray="8 3 2 3" />
      {/* Side view height dim */}
      <line x1="30" y1="210" x2="30" y2="510" stroke={S} strokeWidth="0.5" />
      <line x1="22" y1="210" x2="38" y2="210" stroke={S} strokeWidth="0.5" />
      <line x1="22" y1="510" x2="38" y2="510" stroke={S} strokeWidth="0.5" />

      {/* Small feature crosshairs */}
      <line x1="590" y1="124" x2="590" y2="136" stroke={S} strokeWidth="0.5" />
      <line x1="584" y1="130" x2="596" y2="130" stroke={S} strokeWidth="0.5" />
      <line x1="590" y1="584" x2="590" y2="596" stroke={S} strokeWidth="0.5" />
      <line x1="584" y1="590" x2="596" y2="590" stroke={S} strokeWidth="0.5" />
    </svg>
  );
}
